import React from 'react'
import classNames from 'classnames'
import { bool, node, object } from 'prop-types'

import { RowContextProvider } from '@/component/Context/RowContext'
import Container from '@/component/Primitive/Container'

import styles from './Row.module.scss'

const Row = ({ row, children, isArticle, flex }) => {
  const rowType = row.attributes && row.attributes[0]
  const isInverse = row.attributes && row.attributes.includes('inverse')
  const isFullWidth = row.attributes && row.attributes.includes('full')
  const isTight = row.attributes && row.attributes.includes('tight')
  const hasWidgets = row.cols.some((col) => col.widgetArea?.widgets?.length > 0)
  if (!hasWidgets) return null

  const rowTypes = {
    default: (
      <Container flex={flex} center gutter size="wide">
        {children}
      </Container>
    ),
    narrow: (
      <Container flex={flex} center gutter size="mediumLarge">
        {children}
      </Container>
    ),
    full: <Container>{children}</Container>
  }

  return (
    <RowContextProvider inverse={isInverse}>
      <div
        className={classNames(
          isFullWidth && styles.full,
          isInverse && styles.inverse,
          isTight && styles.tight
        )}
      >
        {rowTypes[rowType] || null}
      </div>
    </RowContextProvider>
  )
}

Row.propTypes = {
  row: object.isRequired,
  children: node,
  isArticle: bool,
  flex: bool
}

export default Row
